export const getImageSrc = (img) => {
  return process.env.REACT_APP_STORAGE_BASE_URL + img;
};
